module.exports = __webpack_public_path__ + "img/miraculous.a5543551.png";